module.exports = __webpack_public_path__ + "img/2.500b0c39.jpg";